export const shadows = {
  base: '0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1)',
  medium: '0px 4px 4px rgba(0, 0, 0, 0.25), 0px 2px 4px rgba(0, 0, 0, 0.06)',
  large: '0px 4px 6px rgba(0, 0, 0, 0.05)',
  primary: '0px 1px 3px rgba(133, 47, 255, 0.3)',
};
